var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"text-decoration-underline",on:{"click":_vm.goToPlan}},[_vm._v(" "+_vm._s(_vm.planid)+" ")]),(_vm.trial)?_c('span',{staticClass:"ml-1"},[_vm._v(" (Trial plan) ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }